// Job actions
export const GET_JOBS_LOADING = "GET_JOBS_LOADING";
export const GET_JOBS_SUCCESS = "GET_JOBS_SUCCESS";
export const GET_JOBS_ERROR = "GET_JOBS_ERROR";
export const SEARCH_JOB_LOADING = "SEARCH_JOB_LOADING";
export const SEARCH_JOB_SUCCESS = "SEARCH_JOB_SUCCESS";
export const SEARCH_JOB_ERROR = "SEARCH_JOB_ERROR";

// User actions
export const SAVE_JOB_LOADING = "SAVE_JOB_LOADING";
export const SAVE_JOB_SUCCESS = "SAVE_JOB_SUCCESS";
export const SAVE_JOB_ERROR = "SAVE_JOB_ERROR";
export const UNSAVE_JOB_LOADING = "UNSAVE_JOB_LOADING";
export const UNSAVE_JOB_SUCCESS = "UNSAVE_JOB_SUCCESS";
export const UNSAVE_JOB_ERROR = "UNSAVE_JOB_ERROR";
export const REGISTER_USER_LOADING = "REGISTER_USER_LOADING";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";

// Common actions
export const CLEAR_STATE = "CLEAR_STATE";
